/**
 * Utility function to check if an error is already a domain error
 */

import type { DomainError } from '@core/domain/errors';

/**
 * Checks if the given error is already a domain error
 */
export function isDomainError(error: unknown): error is DomainError {
  return typeof error === 'object' && error !== null && 'userMessage' in error && 'category' in error && 'code' in error;
}
